import React, { PropTypes, Component } from 'react';
import { InvitationActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import InvitationDetail from 'components/Route/Invitation/Detail';
import { InvitationStore } from 'stores';
import Loader from 'components/Material/Loader';

class InvitationDetailContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStoreWithMapper(InvitationStore, state => ({
      invitation: state.invitation,
    }));
  }

  componentWillMount() {
    if (super.componentWillMount) {
      super.componentWillMount();
    }
    InvitationActions.showInfo(this.props.params.invitationId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.routeParams.invitationId !== nextProps.routeParams.invitationId
    ) {
      InvitationActions.showInfo(nextProps.routeParams.invitationId);
    }
  }

  render() {
    const { invitation } = this.state;
    if (invitation.loading) {
      return <Loader />;
    }
    return (
      <InvitationDetail
        id={invitation.id}
        invitation={invitation}
        onClose={this.props.router.goBack}
      />
    );
  }
}

export default InvitationDetailContainer;



// WEBPACK FOOTER //
// ./src/js/containers/InvitationDetailContainer.js